import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container } from 'react-bootstrap';
import FiscContratosService from '../../../../../../services/fiscContratos-auth';
import { Link } from 'react-router-dom';
import '../../../../../../styles/diario.scss';



const FormBusca = (props) => {
    const [servidor, setServidor] = useState("");
    const [secretaria, setSecretaria] = useState("");
    const [ano, setAno] = useState("");
    const [matricula, setMatricula] = useState("");
    const [referencia, setReferencia] = useState("");

    const busca = async (query) => {
        if (query == "") {
            await props.fetchFiscais()
            setServidor("")
            setSecretaria("")
            setAno("")
            setMatricula("")
            setReferencia("")
        } else {
            var response = await FiscContratosService.buscar(query)
            if (response.data.length >= 1) {
                props.setFiscais(response.data)
                props.setVazio(false)
                setServidor("")
                setSecretaria("")
                setAno("")
                setMatricula("")
                setReferencia("")
            } else {
                props.setVazio(true)
                setServidor("")
                setSecretaria("")
                setAno("")
                setMatricula("")
                setReferencia("")
            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (servidor) prepQuery = prepQuery + `&servidor=${encodeURI(servidor)}`;
        if (matricula) prepQuery = prepQuery + `&matricula=${encodeURI(matricula)}`;
        if (secretaria !== "false" && secretaria != "false" && secretaria !== "") prepQuery = prepQuery + `&secretaria=${encodeURI(secretaria)}`;
        if (referencia !== "false" && referencia != "false" && referencia !== "") prepQuery = prepQuery + `&referencia=${encodeURI(referencia)}`;
        if (ano !== "false" && ano != "false" && ano !== "") prepQuery = prepQuery + `&ano=${encodeURI(ano)}`;
        return prepQuery;
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={2}>
                        <Col lg={9}>
                            <Row xs={1} lg={2}>
                                <Col xs={12} lg={12}>
                                    <Form.Group className="mb-3" controlId="servidor">
                                        <FloatingLabel
                                            label="Servidor"
                                            className="mb-3"
                                        >
                                            <Form.Control
                                                required
                                                type="text"
                                                name="servidor"
                                                value={servidor}
                                                onChange={e => setServidor(e.target.value)} />
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                                <Col lg={4}>
                                    <Form.Group className="mb-3" controlId="Plataforma">
                                        <FloatingLabel
                                            label="Secretarias"
                                            className="mb-3"
                                        >
                                            <Form.Select
                                                required
                                                aria-label="Secretarias"
                                                name="secretaria"
                                                onChange={e => setSecretaria(e.target.value)}
                                            >
                                                <option>SELECIONE</option>
                                                {props.secs.map((sec) =>
                                                    <option value={sec.secretaria}>{sec.secretaria}</option>
                                                )}
                                            </Form.Select>
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={3}>
                                    <Form.Group className="mb-3" controlId="matricula">
                                        <FloatingLabel
                                            label="Matrícula"
                                            className="mb-3"
                                        >
                                            <Form.Control
                                                required
                                                type="text"
                                                name="matricula"
                                                value={matricula}
                                                onChange={e => setMatricula(e.target.value)} />
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={3}>
                                    <Form.Group className="mb-3" controlId="Referencia">
                                        <FloatingLabel
                                            label="Referência"
                                            className="mb-3"
                                        >
                                            <Form.Select
                                                required
                                                aria-label="referencia"
                                                name="referencia"
                                                onChange={e => setReferencia(e.target.value)}
                                            >
                                                <option>TODAS</option>
                                                <option value="1º Semestre">1º Semestre</option>
                                                <option value="2º Semestre">2º Semestre</option>
                                            </Form.Select>
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={2}>
                                    <Form.Group className="mb-3" controlId="Ano">
                                        <FloatingLabel
                                            label="Ano"
                                            className="mb-3"
                                        >
                                            <Form.Select
                                                required
                                                aria-label="ano"
                                                name="ano"
                                                onChange={e => setAno(e.target.value)}
                                            >
                                                <option>TODOS</option>
                                                <option value="2025">2025</option>
                                                <option value="2024">2024</option>
                                                <option value="2023">2023</option>
                                                <option value="2022">2022</option>
                                                <option value="2021">2021</option>
                                                <option value="2020">2020</option>
                                                <option value="2019">2019</option>
                                            </Form.Select>
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Link to='/restrito/contratos/fiscais'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca
